<template>
	<div class="callback"></div>
</template>

<script>
export default {
	name: 'Callback',
	params: {
		access_token: String
	},
	components: {},
	data: () => ({}),
	computed: {},
	mounted() {
		this.init()
	},
	methods: {
		init() {
			if (this.$route.params) {
				this.$store.commit('setAccessToken', this.$route.params.access_token)
				this.$store.commit('isCallbackRoute', false)
				this.$store.dispatch('getLoginState')
				this.$router.push('/')
			}
		}
	}
}
</script>
